import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import App from "./App";
import Login from "./pages/Login/Login";
import InputForm from "./pages/InputForm/InputForm";
import Snapshots from "./pages/Snapshots/Snapshots";
import TreeMap from "./pages/Reports/TreeMap/TreeMap";
import TextReport from "./pages/Reports/TextReport/TextReport";
import EvidenceMap from "./pages/Reports/EvidenceMap/EvidenceMap";
import { RepoProvider } from "./components/context/RepoContext";
import DataRequests from "./pages/DataRequests/DataRequests";
import ExternalForm from "./pages/DataRequests/ExternalForm";
import { DataRequestProvider } from "./components/context/DataRequestContext";
import Files from "./pages/Reports/Files/Files";

/*
  Contains the routing for each page component 
 */

//check if the user is authenticated, or else redirect to login page
const AuthenticatedRoute = ({ element }) => {
  const isAuthenticated = localStorage.getItem("email") !== null;
  return isAuthenticated ? element : <Navigate to="/" />;
};
const company = localStorage.getItem("company");

export default function AppRouter() {
  return (
    <RepoProvider>
      <DataRequestProvider>
        <Router>
          <Routes>
            <Route path="/" element={<App />}>
              {/* Login page */}
              <Route index element={<Login />} />

              {/* Snapshots page */}
              <Route
                path="/snapshots"
                element={<AuthenticatedRoute element={<Snapshots />} />}
              />

              {/* Input form page */}
              <Route
                path="/inputform"
                element={<AuthenticatedRoute element={<InputForm />} />}
              />
              <Route
                path="/inputform/:selectedFileName"
                element={<AuthenticatedRoute element={<InputForm />} />}
              />

              {/* Reports page will show components TextReport, EvidenceMap and TreeMap */}
              <Route
                path="/reports"
                element={<AuthenticatedRoute element={<TextReport />} />}
              />
              <Route
                path="/reports/textreport"
                element={<AuthenticatedRoute element={<TextReport />} />}
              />
              <Route
                path="/reports/evidencemap"
                element={<AuthenticatedRoute element={<EvidenceMap />} />}
              />
              <Route
                path="/reports/treemap"
                element={<AuthenticatedRoute element={<TreeMap />} />}
              />
               <Route
                path="/reports/files"
                element={<AuthenticatedRoute element={<Files />} />}
              />

              <Route
                path="/datarequests"
                element={<AuthenticatedRoute element={<DataRequests />} />}
              />
              {/* Form To be completed by External Member */}
              <Route path={`/:company/:formId`} element={<ExternalForm />} />
            </Route>
          </Routes>
        </Router>
      </DataRequestProvider>
    </RepoProvider>
  );
}
